<template>
<div>
  <div>
    <figure class="image is-48x48 is-cursor-pointer" @click="connect(id)" :title="name">
      <img :src="getWalletIcon(id)" class="is-rounded" :alt="name" />
      <span v-if="isActive && connecting" >
        <i class="fas fa-spinner fa-spin"></i>
      </span>
    </figure>
    <h4  class="m-t-8">{{name}}</h4>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import scatterIcon from '@/assets/scatter@3x.svg'
import tpIcon from '@/assets/tokenpocket@3x.jpeg'
import lynx from '@/assets/lynx.png'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    isWallet: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('sigproviders', [
      'connecting',
      'connected',
      'activeProvider'
    ]),
    ...mapGetters('sigproviders', [
      'providers',
      'account'
    ]),
    getProvidersList () {
      const prods = []
      this.providers.forEach(p => {
        prods.push(p.meta.shortName)
      })
      return prods.join(', ')
    },
    isActive () {
      if (this.activeProvider) {
        return this.activeProvider.id === this.id
      }
      return false
    }
  },
  methods: {
    connect (walletId) {
      this.$store.dispatch('sigproviders/attachWallet', walletId)
    },
    getWalletIcon (walletId) {
      switch (walletId) {
        case 'scatter':
          return scatterIcon
        case 'TokenPocket':
          return tpIcon
        case 'EOS Lynx':
          return lynx
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  figure {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/wallet/provider-with-icon.vue